import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 24px;

  width: 100%;
  max-width: 396px;

  background: #FFFFFF;
  border-radius: 12px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.h2`
  width: 100%;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 29px;
  color: #2B313C;
  text-align: center;

  span {
    color: #59249B;
  }
`;

export const Subtitle = styled.p`
  width: 100%;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #2B313C;
  text-align: center;
`;

export const PhoneImage = styled.img`
  width: auto;
  max-width: 200px;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  margin: 16px 0;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 24px;
  width: 100%;
`;

export const PrimaryButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  width: 100%;
  min-height: 60px;
  background: #59249B;
  border-radius: 300px;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #4a1d82;
  }

  &:active {
    background: #3d1870;
  }
`;

export const PrimaryButtonText = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #FFFFFF;
`;

export const PrimaryButtonSubtext = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
`;

export const SecondaryButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #2B313C;
  padding: 8px 16px;
  
  &:hover {
    text-decoration: underline;
  }
`;

// iOS Instructions Modal Styles
export const InstructionsOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 16px;
`;

export const InstructionsModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 16px;
  width: 100%;
  max-width: 360px;
  background: #FFFFFF;
  border-radius: 12px;
`;

export const InstructionsTitle = styled.h2`
  width: 100%;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #2B313C;
  text-align: center;

  span {
    color: #59249B;
  }
`;

export const InstructionsList = styled.ol`
  width: 100%;
  padding-left: 24px;
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  line-height: 24px;
  color: #2B313C;

  li {
    margin-bottom: 8px;
  }

  strong {
    color: #59249B;
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin: 0 4px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #6B7280;
  
  &:hover {
    color: #2B313C;
  }
`;
